if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if(!this.form?.classList.contains('product-bundle-form')) this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.body.classList.contains("template-cart") ? document.querySelector('cart-items') : document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {

        
        
        evt.preventDefault();

        //===============custom for prevent add to cart
       
        if(this.getAttribute('data-product-id') == this.closest('product-info')?.getAttribute('data-product-id')) {
          let temp_flag = false;
          const customDropDowns = document.querySelectorAll('product-info custom-dropdown');
          customDropDowns.forEach((dropdown)=> {
            const flagValue = dropdown.getAttribute('js-custom-dropdown');
            if(flagValue == 'true') {
              temp_flag = true;
              dropdown.classList.add('open');
            }
          });
          if(temp_flag == true) return;
        }
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if(!document.body.classList.contains("template-cart")) this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;


        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                if(document.body.classList.contains("template-cart")) {
                  this.cart.getSectionsToRender().forEach((section) => {
                    const elementToReplace =
                      document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                    elementToReplace.innerHTML = this.cart.getSectionInnerHTML(
                      response.sections[section.section],
                      section.selector
                    );
                  });
                }else {
                  this.cart.renderContents(response);
                }
              });
            }

            
            //=====================DataSlayer Script
            //console.log('data - SB', response);
            window.dataLayer = window.dataLayer || [];
            if (response.items && Array.isArray(response.items)) {
                const lineBundleItemTitles = response.items[0].properties && response.items[0].properties._bundle_item;
                const line_bundle_items = lineBundleItemTitles
                ? lineBundleItemTitles.split(',').map(title => ({ title: title.trim() }))
                : undefined;

                if(line_bundle_items) {
                  const bundleItems = document.querySelectorAll("product-bundle-item");
                  if(bundleItems.length) {
                    const items = [];
                    const products = [];
                    bundleItems.forEach(el => {
                      const variantId = Number(el.getAttribute("data-selected-variant-id"));
                      const productId = Number(el.getAttribute("data-id"));
                      const productTitle = el.getAttribute("data-product-title");
                      const productVendor = el.getAttribute("data-product-vendor");
                      const productType = el.getAttribute("data-product-type");
                      const variantTitle = el.getAttribute("data-variant-title");
                      const variantUrl = el.getAttribute("data-variant-url");
                      const variantPrice = Number(el.getAttribute("data-variant-price"));
                      const productSku = el.getAttribute("data-product-sku");
                      const productUrl = el.getAttribute("data-product-url");
                      const variantMoneyPrice = el.getAttribute("data-variant-money-price");

                      items.push({
                        item_type: 'Multi-Variant Bundle',
                        item_id: productId,
                        item_name: productTitle,
                        affiliation: 'Shopify Online Store',
                        discount: undefined,
                        item_brand: productVendor,
                        item_category: productType,
                        item_variant: variantId,
                        item_variant_name: variantTitle,
                        item_list_id: variantUrl,
                        item_list_name: productTitle,
                        price: variantPrice, 
                        quantity: 1
                      });
                      products.push({
                        product_id: `${productId}`,
                        product_title: productTitle,
                        product_type: 'Multi-Variant Bundle',
                        product_vendor: productVendor,
                        product_url: productUrl,
                        product_variant_title: variantTitle,
                        product_variant_id: `${variantId}`,
                        product_sku: productSku,
                        price: variantMoneyPrice,
                        quantity: 1,
                        selling_plan_id: null
                      });
                    });

                    if(items.length) {
                      window.dataLayer.push({
                        event: 'product_added_to_cart',
                        currency: Shopify.currency.active,
                        value: response.presentment_price || '',
                        shopify_client_id: this.generateUUID(),
                        url: location.href,
                        ecommerce: {
                          items: items,
                          products: products
                        }
                      });
                    }
                  }
                }
                // else {
                //   const items = [];
                //   response.items.forEach(item => {
                //     const bundleItemTitles = item.properties && item.properties._bundle_item;
                //     const bundle_items = bundleItemTitles
                //     ? bundleItemTitles.split(',').map(title => ({ title: title.trim() }))
                //     : undefined;
                    
                //     items.push({
                //         item_id: item.product_id,
                //         item_name: item.title,
                //         affiliation: 'Shopify Online Store',
                //         discount: item.discounts.length > 0 ? item.discounts[0]: 0,
                //         item_brand: item.vendor,
                //         item_category: item.product_type,
                //         item_variant: item.id,
                //         item_variant_name: item.variant_title,
                //         item_list_id: item.url,
                //         item_list_name: item.product_title,
                //         price: item.presentment_price || '', 
                //         quantity: item.quantity,
                //       ...(bundle_items && {
                //       item_type: 'Bundle',
                //       bundle_items
                //       })
                //     });
                //   });
                //   window.dataLayer.push({
                //     event: 'add_to_cart',
                //     ecommerce: {
                //     items: items
                //     }
                //   });
                // }

            }
            else {

              const bundleItemTitles = response.properties && response.properties._bundle_item;
              const bundle_items = bundleItemTitles
              ? bundleItemTitles.split(',').map(title => ({ title: title.trim() }))
              : undefined;

              if(bundle_items) {
                const bundleItems = document.querySelectorAll("product-bundle-item");
                if(bundleItems.length) {
                  const items = [];
                  const products = [];

                  bundleItems.forEach(el => {
                    const variantId = Number(el.getAttribute("data-selected-variant-id"));
                    const productId = Number(el.getAttribute("data-id"));
                    const productTitle = el.getAttribute("data-product-title");
                    const productVendor = el.getAttribute("data-product-vendor");
                    const productType = el.getAttribute("data-product-type");
                    const variantTitle = el.getAttribute("data-variant-title");
                    const variantUrl = el.getAttribute("data-variant-url");
                    const variantPrice = el.getAttribute("data-variant-price");
                    const productSku = el.getAttribute("data-product-sku");
                    const productUrl = el.getAttribute("data-product-url");
                    const variantMoneyPrice = el.getAttribute("data-variant-money-price");

                    items.push({
                      item_type: 'Multi-Variant Bundle',
                      item_id: productId,
                      item_name: productTitle,
                      affiliation: 'Shopify Online Store',
                      discount: undefined,
                      item_brand: productVendor,
                      item_category: productType,
                      item_variant: variantId,
                      item_variant_name: variantTitle,
                      item_list_id: variantUrl,
                      item_list_name: productTitle,
                      price: variantPrice, 
                      quantity: 1
                    });

                    products.push({
                      product_id: `${productId}`,
                      product_title: productTitle,
                      product_type: 'Multi-Variant Bundle',
                      product_vendor: productVendor,
                      product_url: productUrl,
                      product_variant_title: variantTitle,
                      product_variant_id: `${variantId}`,
                      product_sku: productSku,
                      price: variantMoneyPrice,
                      quantity: 1,
                      selling_plan_id: null
                    });
                  });

                  if(items.length) {
                    window.dataLayer.push({
                      event: 'product_added_to_cart',
                      currency: Shopify.currency.active,
                      value: response.presentment_price || '',
                      shopify_client_id: this.generateUUID(),
                      url: location.href,
                      ecommerce: {
                        items: items,
                        products: products
                      }
                    });
                  }
                }
                
              }
              // else {
              //   window.dataLayer.push({
              //     event: 'add_to_cart',
              //     currency: Shopify.currency.active,
              //     value: response.presentment_price || '',
              //     ecommerce: {
              //       items: [{
              //         item_id: response.product_id,
              //         item_name: response.title,
              //         affiliation: 'Shopify Online Store',
              //         discount: response.discounts.length > 0 ? response.discounts[0]: 0,
              //         item_brand: response.vendor,
              //         item_category: response.product_type,
              //         item_variant: response.id,
              //         item_variant_name: response.variant_title,
              //         item_list_id: response.url,
              //         item_list_name: response.product_title,
              //         price: response.presentment_price || '', 
              //         quantity: response.quantity
              //       }]
              //     }
              //   });
              // }
            }
           
           //console.log('window.dataLayer',  window.dataLayer);
            
            
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        }).toUpperCase();
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
